export default __webpack_public_path__ + "static/media/manBox.5a3bcd49.jpg";